module.exports = __webpack_public_path__ + "img/play-btn.85c589c3.png";